import React, {useEffect, useState} from "react";
import {IDashboardStatistics, IDashboardTestingSpeedDTO, SortedItem, SortedItemSpeed} from "./DashboardTypes";
import {ChartTypeByName} from "./InspectionItemsChart";
import {Card, CardContent, CardHeader, Grid, ToggleButtonGroup, useTheme} from "@mui/material";
import {ICustomerType, IEmployee, IInspectionItem} from "../../rest-data-provider/bfaTypes";
import {BfARefineUtils} from "../../utils/BfARefineUtils";
import {ToggleButton} from "@mui/lab";
import {BarChart} from "@mui/x-charts";

interface InspectionSpeedChartProps {
    data: IDashboardStatistics
}

export const ChartTypeByInspector = 'byInspector'
export const ChartTypeByCustomer = 'byCustomer'
export type ChartType = typeof ChartTypeByInspector|typeof ChartTypeByCustomer;
export const InspectionSpeedChart : React.FC<InspectionSpeedChartProps> = ({data}) => {

    const [chartType, setChartType] = useState<ChartType>(ChartTypeByInspector)
    const [items, setItems] = useState<SortedItemSpeed[]>([])

    const [longestLabel, setLongestLabel] = useState<string>('')
    const [chartMarginLeft, setChartMarginLeft] = useState(0)

    const theme = useTheme();

    const findCustomer = (inspectionId: number) : ICustomerType|null => {
        for (const inspection of data.inspections) {
            if(inspection.id === inspectionId) {
                return inspection.customer;
            }
        }
        return null;
    }

    const findEmployee = (employeeId: number) : IEmployee|null => {
        for (const employee of data.employees) {
            if(employee.id === employeeId) {
                return employee
            }
        }
        return null;
    }

    let numberOfItemsInChart = 10;
    useEffect(() => {
        if(data) {

            let groupedData : Partial<Record<string, IDashboardTestingSpeedDTO[]>> = {}
            if(chartType === ChartTypeByInspector) {
                groupedData = Object.groupBy(data.speed, item => {
                    const employee = findEmployee(item.key.employeeId);
                    return `${employee?.firstName} ${employee?.lastName}`
                })
                numberOfItemsInChart = data.employees.length;
            } else if(chartType === ChartTypeByCustomer) {
                groupedData = Object.groupBy(data.speed, item => findCustomer(item.key.inspectionId)!.name)
                numberOfItemsInChart = 10;
            }

            let marginLeft = 0;
            const sortedItems : SortedItemSpeed[] = [];
            for (const [key, value] of Object.entries(groupedData)) {
                console.log(value);
                let inspectionCount = 0;
                let durationInSeconds = 0;
                let inspectionsPerHour = 0;
                if(value) {
                    for (const valueElement of value) {
                        inspectionCount += valueElement.devicesCount;
                        durationInSeconds += valueElement.durationSeconds;
                    }
                    if (durationInSeconds !== 0) {
                        inspectionsPerHour = Math.round(((inspectionCount / (durationInSeconds / 3600)) * 100) / 100);
                    }
                    const sortedItem = {
                        name: key,
                        inspectionsPerHour: inspectionsPerHour,
                        durationInSeconds: durationInSeconds,
                        inspectionsCount: inspectionCount
                    } as SortedItemSpeed;
                    sortedItems.push(sortedItem);
                }
            }
            sortedItems.sort((a, b) => a.inspectionsPerHour - b.inspectionsPerHour).reverse()


            const compactSortedItems : SortedItemSpeed[] = [];
            for (let i = 0; (i < numberOfItemsInChart && i < sortedItems.length); i++) {
                const textLength = BfARefineUtils.getTextWidth(sortedItems[i].name)
                if(marginLeft < textLength) {
                    marginLeft = textLength;
                    setLongestLabel(sortedItems[i].name);
                }
                compactSortedItems.push(sortedItems[i]);
            }
            setChartMarginLeft(marginLeft + 20);

            let otherInspectionCount = 0;
            let otherDurationInSeconds = 0;
            for (let i = numberOfItemsInChart; i < sortedItems.length; i++) {
                otherInspectionCount += sortedItems[i].inspectionsCount;
                otherDurationInSeconds += sortedItems[i].durationInSeconds;
            }

            if(otherInspectionCount > 0 || otherDurationInSeconds > 0) {
                compactSortedItems.push({
                    name: 'Sonstige',
                    inspectionsPerHour: otherInspectionCount / (otherDurationInSeconds / 3600),
                    durationInSeconds: otherDurationInSeconds,
                    inspectionsCount: otherInspectionCount
                } as SortedItemSpeed)
            }
            setItems(compactSortedItems);

        }
    }, [data, chartType])


    return (
        <>
            {/*<div style={{display: 'flex', justifyContent: 'center', marginTop: '20px'}}>*/}
            {/*    <ToggleButtonGroup*/}
            {/*        color="primary"*/}
            {/*        size={'small'}*/}
            {/*        value={chartType}*/}
            {/*        exclusive*/}
            {/*        onChange={(event, value) => {*/}
            {/*            if (value) {*/}
            {/*                setChartType(value)*/}
            {/*            }*/}

            {/*        }}*/}
            {/*        aria-label="Platform"*/}
            {/*    >*/}
            {/*        <ToggleButton sx={{*/}
            {/*            '&.Mui-selected': {*/}
            {/*                fontWeight: 'bold'*/}
            {/*            }*/}
            {/*        }} value={ChartTypeByName}>nach Gerätetyp</ToggleButton>*/}
            {/*        <ToggleButton sx={{*/}
            {/*            '&.Mui-selected': {*/}
            {/*                fontWeight: 'bold'*/}
            {/*            }*/}
            {/*        }} value={ChartTypeByInspector}>nach Prüfer</ToggleButton>*/}
            {/*        <ToggleButton sx={{*/}
            {/*            '&.Mui-selected': {*/}
            {/*                fontWeight: 'bold'*/}
            {/*            }*/}
            {/*        }} value={ChartTypeByCustomer}>nach Kunde</ToggleButton>*/}
            {/*    </ToggleButtonGroup>*/}
            {/*</div>*/}
            <h3 style={{paddingLeft: '20px'}}>Workload je Prüfer</h3>
            {items.length === 0 && (
                <h3 style={{color: 'grey', textAlign: 'center'}}>Für die Auswahl sind keine Daten vorhanden</h3>
            )}

            {items && items.length > 0 && (
                // <>
                //     <BarChart
                //         sx={{
                //             marginBottom: '10px',
                //             '& .MuiBarLabel-root': {
                //                 fontWeight: 'bold',
                //                 fill: 'red',
                //
                //                 // transform: 'translateX(100px)'
                //             }
                //         }}
                //         margin={{left: chartMarginLeft}}
                //         dataset={items}
                //         yAxis={[{scaleType: 'band', dataKey: 'name',}]}
                //         xAxis={[{label: 'Anzahl Prüflinge pro Stunde'}]}
                //         series={[{
                //             dataKey: 'inspectionsPerHour',
                //             stack: 'test',
                //             label: 'Anzahl Prüflinge pro Stunde',
                //             id: 'countPerHour',
                //             color: theme.palette.primary.main,
                //         }
                //         ]}
                //         layout="horizontal"
                //         barLabel={(item, context) => {
                //             // console.log(item, context)
                //             if (item.seriesId === 'countPerHour' && context.bar.width > 45) {
                //                 return "" + ((items[item.dataIndex].inspectionsCount));
                //             }
                //             return '';
                //         }}
                //         height={500}
                //     />
                // </>
                <>
                    {items && items.length > 0 && items.map(value => {
                        return <Card variant={'outlined'} elevation={4} key={value.name} style={{margin: '10px'}}>
                            <CardContent style={{padding: 0}}>
                                <Grid container spacing={2} style={{height: '100%', padding: '10px'}}>
                                    <Grid item xs={6} style={{display: 'flex', placeContent: 'start', placeItems: 'center', flexDirection: 'row'}}>
                                        <label style={{fontWeight: 'bold'}}>{value.name}</label>
                                    </Grid>
                                    <Grid item xs={6} style={{display: 'flex', placeContent: 'end', placeItems: 'center', flexDirection: 'column'}}>
                                        <p style={{margin: 0}}><b>{value.inspectionsPerHour}</b>&nbsp;Geräte pro Stunde</p>
                                        <p style={{margin: 0, fontSize: '12px'}}><b>{value.inspectionsCount}</b> Geräte in <b>{(value.durationInSeconds / 3600).toFixed(1)}</b> Stunden</p>
                                    </Grid>
                                </Grid>

                            </CardContent>
                        </Card>
                    })}
                </>
            )}
            {/*<canvas width={'1000px'} ref={canvas}>*/}
            {/*</canvas>*/}

        </>
    )
}